import React, { useContext, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import MultiSelect from "multiselect-react-dropdown";
import { AppContext } from "../contexts/AppContext";
import { AuthContext } from "../contexts/AuthContext";
import { updateProfile, getuserInfo } from "../store/actions/userActions";
import axiosHttp from "../config/axios.interceptor";
import { errorResponseMessage } from "./const.prop";

const AddSkills = () => {
  const appContext = useContext(AppContext);
  const authContext = useContext(AuthContext);
  const dispatch = useDispatch();
  const { userData } = useSelector((state) => state.user);
  const [skillInfo, setSkillInfo] = useState([]);
  const [error, setError] = useState("");
  const [value, setValue] = useState("");
  const [optionList, setOptionList] = useState([]);

  useEffect(() => {
    if (userData && userData?.skills && userData?.skills?.length > 0) {
      setSkillInfo(userData.skills);
    }
  }, [userData]);

  useEffect(() => {
    if (value !== "") {
      const getData = setTimeout(fetchSkillsList, 2000);
      return () => clearTimeout(getData);
    }
  }, [value]);

  const fetchSkillsList = async () => {
    try {
      const getSkillsList = await axiosHttp.get(`skills-new?skill=${value}`);
      setOptionList(getSkillsList.data.data);
    } catch (error) {
      if (error.response.status === 429) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(error),
          type: "error",
        });
        authContext.logout();
      }
      if (error.response.status === 400) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(error),
          type: "error",
        });
      }
      if (error.response?.status >= 500) {
        appContext.updateNotificationState({
          show: true,
          message: "Something went wrong, please try again later.",
          type: "error",
        });
      }
      setOptionList([]);
    }
  };

  const successCallback = () => {
    dispatch(getuserInfo());
    // appContext.updateNotificationState({
    //   type: "success",
    //   message: "Skills updated successfully",
    //   show: true,
    // });
    appContext.updateModalState();
  };

  const failureCallback = (e) => {
    if (e.response.status === 429) {
      appContext.updateNotificationState({
        show: true,
        type: "error",
        message: errorResponseMessage(e),
      });
      authContext.logout();
    }
    appContext.updateNotificationState({
      show: true,
      type: "error",
      message: e?.response?.data?.message,
    });
    appContext.updateModalState();
  };

  const formValidation = (skillInfo) => {
    if (!skillInfo || skillInfo.length === 0) {
      return "Please select at least one skill";
    }

    const values = new Set();
    for (const item of skillInfo) {
      if (values.has(item.value)) {
        return "Duplicate entries are not allowed";
      }
      values.add(item.value);
    }

    return true;
  };

  const handleSubmit = () => {
    const validationResult = formValidation(skillInfo);

    if (validationResult === true) {
      dispatch(
        updateProfile(
          {
            skills: [...skillInfo],
          },
          successCallback,
          failureCallback
        )
      );
    } else {
      setError(true);
      appContext.updateNotificationState({
        show: true,
        type: "error",
        message: validationResult,
      });
    }
  };
  const handleSelection = (value) => {
    const isElePresent = skillInfo.some((item) => item === value?.value);
    if (!isElePresent) {
      setSkillInfo([...skillInfo, value]);
    }
    return;
  };

  return (
    <>
      <div
        className="modal-body"
        style={{ maxHeight: "26rem", overflow: "hidden auto" }}
      >
        <div className="row mt-4">
          <div className="col-md-12">
            <div className="form-group input-group">
              <label className="has-float-label">
                <MultiSelect
                  options={[]}
                  hidePlaceholder={true}
                  onRemove={(removedItem) => setSkillInfo([...removedItem])}
                  selectedValues={[...skillInfo]}
                  displayValue="value"
                  // isObject={false}
                  onSearch={(skillValue) => {
                    setValue(skillValue);
                  }}
                  className="multi-select-wrapper"
                />
                <span>Skill</span>
              </label>
            </div>
            {error && !skillInfo.length && (
              <p className="field-error">Select atleast one skill</p>
            )}
            {error && skillInfo.length > 0 && (
              <p className="field-error">Duplicate entries are not allowed</p>
            )}
          </div>
        </div>
        <div className="row mt-4">
          <div className="col-md-12">
            <div className="card card-modal">
              <div className="card-body">
                <p className="sugges">Suggested based on your profile</p>

                <div className="">
                  {optionList.map((item) => {
                    return (
                      <button
                        type="button"
                        className="btn btn-outline-secondary sug-btn mr-1 mb-3"
                        onClick={() =>
                          handleSelection({
                            value: item,
                          })
                        }
                      >
                        {item}
                      </button>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-footer mt-2 mb-3">
        <button
          type="button"
          className="btn btn-outline-primary prime-btn"
          data-dismiss="modal"
          onClick={appContext.updateModalState}
        >
          Cancel
        </button>
        <button
          type="button"
          className="btn btn-outline-primary modal-btn"
          onClick={handleSubmit}
        >
          Save
        </button>
      </div>
    </>
  );
};

export default AddSkills;
